import type { StructuredDataFieldMapping } from "@autodromo/schema-catalog";

interface RelationGroup {
  contentTypeSlug?: string;
  items?: Array<Record<string, any>>;
}

interface RelationFieldValuesParams {
  /** Registro no formato público do CMS, com `relations` quando houve pedido. */
  item: Record<string, any>;
  mappings: readonly StructuredDataFieldMapping[];
}

interface RelationFieldValues {
  values: Record<string, unknown>;
  fieldTypes: Record<string, string>;
}

/**
 * Valores e tipos dos campos que vêm de um tipo relacionado, sob a mesma chave
 * composta que o mapeamento usa (`modelo.name`).
 * Relação ausente, vazia, ou item sem o campo simplesmente não contribui, e a propriedade fica de fora do nó.
 */
export function relationFieldValues({
  item,
  mappings,
}: RelationFieldValuesParams): RelationFieldValues {
  const relations: Record<string, RelationGroup> = item?.relations ?? {};
  const values: Record<string, unknown> = {};
  const fieldTypes: Record<string, string> = {};

  mappings.forEach(({ field, relation }) => {
    if (!relation) return;

    const related = relations[relation]?.items?.[0];
    if (!related) return;

    const [, ...rest] = field.split(".");
    const name = rest.join(".");
    if (name.length === 0) return;

    values[field] = related[name];

    const type = (related?._metadata?.fields ?? []).find(
      (candidate: { name: string }) => candidate.name === name,
    )?.type;

    if (type) fieldTypes[field] = type;
  });

  return { values, fieldTypes };
}
